<template>
    <div class="container">
        <div class="page-wrap d-flex flex-row align-items-center">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-12 text-center">
                        <span class="display-1 d-block">
                            401
                        </span>
                        <div class="mb-4 lead">
                            Sem autorização! Você não tem acesso a esa página.
                        </div>
                        <a href="/" class="btn btn-link">Voltar para Página Inicial</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'unalthorized'
}
</script>
<style>

</style>

